/* SOCIALLY RECLUSIVE — reveal.js
   Fade-up on scroll via IntersectionObserver.
   - Opts in with [data-reveal]; optional [data-reveal-delay="100"] (ms) to stagger.
   - Above-the-fold elements reveal immediately.
   - Progressive enhancement: hidden state only applies when <html class="reveal-ready">
     is set (by the inline guard in theme.liquid). No JS / no support => content visible.
   - prefers-reduced-motion: bail out entirely, content stays visible. */
(function () {
  "use strict";
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // If we can't (or shouldn't) animate, leave everything visible and stop.
  if (reduce || !("IntersectionObserver" in window)) {
    root.classList.remove("reveal-ready");
    return;
  }

  function reveal(el) {
    var d = el.getAttribute("data-reveal-delay");
    if (d) el.style.setProperty("--reveal-delay", (parseInt(d, 10) || 0) + "ms");
    el.classList.add("is-revealed");
  }

  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].isIntersecting) {
        reveal(entries[i].target);
        io.unobserve(entries[i].target); // once only — never re-hide
      }
    }
  }, { rootMargin: "0px 0px -10% 0px", threshold: 0.1 });

  function init() {
    var vh = window.innerHeight || root.clientHeight;
    var els = document.querySelectorAll("[data-reveal]");
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.getBoundingClientRect().top < vh) reveal(el); // already in view at load
      else io.observe(el);
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
